import React, {useState, useEffect} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    Button,
    Spinner,
    Badge,
    Alert,
    Table, Modal
} from 'react-bootstrap';
import {FaArrowLeft, FaDownload, FaEye} from 'react-icons/fa';
import TransportService from '../services/TransportService';
import FaylService from '../services/FaylService';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Utils from "../utils/Utils";
import ShowPutyovka from "./show/ShowPutyovka";
import './show/ShowPut.css'
import ShowLitsenziya from "./show/ShowLitsenziya";
import ShowIjara from "./show/ShowIjara";
import TransportTarix from "./TransportTarix";
import {TimeIcon} from "@mui/x-date-pickers";

const TransportShow = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [transport, setTransport] = useState(null);
    const [error, setError] = useState(null);
    const [showPut, setShowPut] = useState(false);
    const [showIj, setShowIj] = useState(false);
    const [showLit, setShowLit] = useState(false);

    const [showBalanceTarixModal, setShowBalanceTarixModal] = useState(false);

    useEffect(() => {
        const fetchTransport = async () => {
            try {
                setLoading(true);
                const response = await TransportService.transportShow(id);
                if (response.success) {
                    setTransport(response.data);
                } else {
                    setError('Transport ma\'lumotlari topilmadi');
                }
            } catch (err) {
                console.error('Error fetching transport:', err);
                setError('Xatolik yuz berdi. Qaytadan urinib ko\'ring.');
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchTransport();
        }
    }, [id]);

    const handleDownload = async (fayl) => {
        if (!fayl || fayl === 'no_file' || fayl === 'undefined') {
            console.log('toastga keldi'); // 👈 log kelyaptimi?
            toast.error('Fayl mavjud emas');
            return;
        }
        try {
            const fileUrl = FaylService.getFaylPath(fayl);
            window.open(fileUrl, '_blank');
        } catch (err) {
            console.error('Error downloading file:', err);
            toast.error('Faylni yuklab olishda xatolik');
        }
    };

    const handlePdfGenerate = async (item, global) => {
        if (!item?.id) {
            toast.error('Fayl olishda xatolik');
            return;
        }

        const token = localStorage.getItem('token');
        const url = `https://logistika.smart-trade.uz/api/pdf_generator/putyofka/${item.id}?global=${global}&token=${token}`;

        window.open(url, '_blank');
    };

    const getStatusBadge = (gacha) => {
        const today = new Date();
        const endDate = new Date(gacha);
        const diffTime = endDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 0) return <Badge bg="danger">Muddati o'tgan</Badge>;
        if (diffDays < 7) return <Badge bg="warning" text="dark">Muddati yaqinlashmoqda</Badge>;
        return <Badge bg="success">Faol</Badge>;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{minHeight: '60vh'}}>
                <Spinner animation="border" variant="primary"/>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-4">

                <Alert variant="danger">
                    <Alert.Heading>Xatolik!</Alert.Heading>
                    <p>{error}</p>
                    <Button variant="outline-danger" onClick={() => navigate(-1)}>
                        <FaArrowLeft className="me-2"/> Orqaga qaytish
                    </Button>
                </Alert>
            </Container>
        );
    }

    if (!transport) {
        return (
            <Container className="mt-4">
                <Alert variant="warning">
                    <Alert.Heading>Ma'lumot topilmadi</Alert.Heading>
                    <p>So'ralgan transport topilmadi yoki o'chirilgan bo'lishi mumkin.</p>
                    <Button variant="outline-warning" onClick={() => navigate(-1)}>
                        <FaArrowLeft className="me-2"/> Orqaga qaytish
                    </Button>
                </Alert>
            </Container>
        );
    }

    const latestLitsenziya = transport.litsenziya?.[0];
    const latestIjara = transport.ijara?.[0];
    const latestPutyovka = transport.putyofkas?.[0];

    return (
        <Container className="py-4">

            <Button
                variant="outline-secondary"
                className="mb-4"
                onClick={() => navigate(-1)}
            >
                <FaArrowLeft className="me-2"/> Orqaga
            </Button>

            {/* Transport Info Card */}
            <Card className="mb-4 shadow-sm">
                <Card.Body>
                    {/*<ToastContainer/>*/}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h2 className="mb-0">
                            {/*<Badge bg="primary" className="me-1">*/}
                            {/*{transport.name}*/}
                            {/*</Badge>*/}
                            {transport.name}
                        </h2>
                        <h3 className={`mb-0 ${transport.balance < 0 ? 'text-danger' : 'text-success'}`}>
                            <Badge key={transport.id} bg={`${transport.balance < 0 ? 'danger' : 'success'}`}
                                   className="me-1">
                                {Utils.formatSumUZS(transport.balance)} UZS
                            </Badge>
                            {/*{transport.balance} UZS*/}
                        </h3>
                    </div>

                    <Row className="mb-3">
                        <Col md={6}>
                            <p className="mb-1"><strong>Davlat raqami: </strong>
                                {/*<Badge bg="secondary" className="me-1 fs-6">*/}
                                {/*  {transport.davlat_raqam || 'N/A'}*/}
                                {/*</Badge>*/}
                                {transport.davlat_raqam || 'N/A'}

                            </p>
                            <p className="mb-1"><strong>Tex passport raqami: </strong>
                                {/*<Badge bg="secondary" className="me-1 fs-6">*/}
                                {/*  {transport.tex_passport_raqam || 'N/A'}*/}
                                {/*</Badge>*/}
                                {transport.tex_passport_raqam || 'N/A'}
                            </p>
                        </Col>
                        <Col md={6}>
                            <p className="mb-1"><strong>Ega: </strong>
                                {/*<Badge bg="secondary" className="me-1 fs-6">*/}
                                {/*  {transport.ega?.name || 'N/A'}*/}
                                {/*</Badge>*/}
                                {transport.ega?.name || 'N/A'}
                            </p>
                            <p className="mb-0"><strong>Telefon: </strong>
                                {/*<Badge bg="secondary" className="me-1 fs-7">*/}
                                {/*  {transport.ega?.phone || 'N/A'}*/}
                                {/*</Badge>*/}
                                {transport.ega?.phone || 'N/A'}
                            </p>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Status Cards */}
            <Row className="mb-4">

                {/* Putyovka Card */}
                <Col md={4} className="mb-3">
                    <Card className="h-100 shadow-sm">
                        <Card.Header className="bg-warning">
                            <Card.Title className="mb-0">Putyovka</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            {latestPutyovka ? (
                                <>
                                    <p><strong>Raqam:</strong> {latestPutyovka.raqam}</p>
                                    <p>
                                        <strong>Muddati:</strong> {Utils.getDayDifference(latestPutyovka.dan, latestPutyovka.gacha)} kun
                                        -> {formatDate(latestPutyovka.dan)} - {formatDate(latestPutyovka.gacha)}</p>
                                    <p><strong>Narx:</strong> {Utils.formatSumUZS(latestPutyovka.narx) || '0'} UZS</p>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span>{getStatusBadge(latestPutyovka.gacha)}</span>
                                        <Button
                                            variant="outline-warning"
                                            size="sm"
                                            onClick={() => handlePdfGenerate(latestPutyovka, 0)}
                                        >
                                            <FaDownload className="me-1"/> Yuklash
                                        </Button>
                                        <Button
                                            variant="outline-warning"
                                            size="sm"
                                            onClick={() => handlePdfGenerate(latestPutyovka, 1)}
                                        >
                                            <FaDownload className=""/> Xalqaroni yuklash
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <p className="text-muted">Putyovka mavjud emas</p>
                            )}
                        </Card.Body>
                        <Card.Footer className="text-center">
                            <Button
                                variant="link"
                                size="sm"
                                onClick={() => {
                                    // navigate(`/putyovka/history/${transport.id}`)
                                    setShowPut(true)
                                }}
                            >
                                <FaEye className="me-1"/> Barcha putyovkalar
                            </Button>
                        </Card.Footer>
                    </Card>
                </Col>

                {/* Litsenziya Card */}
                <Col md={4} className="mb-3">
                    <Card className="h-100 shadow-sm">
                        <Card.Header className="bg-primary text-white">
                            <Card.Title className="mb-0">Litsenziya</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            {latestLitsenziya ? (
                                <>
                                    <p><strong>Raqam:</strong> {latestLitsenziya.raqam}</p>
                                    <p>
                                        <strong>Muddati:</strong> {Utils.getDayDifference(latestLitsenziya.dan, latestLitsenziya.gacha)} kun
                                        -> {formatDate(latestLitsenziya.dan)} - {formatDate(latestLitsenziya.gacha)}</p>
                                    <p><strong>Narx:</strong> {Utils.formatSumUZS(latestLitsenziya.narx) || '0'} UZS</p>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span>{getStatusBadge(latestLitsenziya.gacha)}</span>
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() => handleDownload(latestLitsenziya.fayl)}
                                        >
                                            <FaDownload className="me-1"/> Yuklab olish
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <p className="text-muted">Litsenziya mavjud emas</p>
                            )}
                        </Card.Body>
                        <Card.Footer className="text-center">
                            <Button
                                variant="link"
                                size="sm"
                                onClick={() => {
                                    setShowLit(true);
                                }
                                    // navigate(`/litsenziya?transport_id=${transport.id}`)
                                }
                            >
                                <FaEye className="me-1"/> Barcha litsenziyalar
                            </Button>
                        </Card.Footer>
                    </Card>
                </Col>

                {/* Ijara Card */}
                <Col md={4} className="mb-3">
                    <Card className="h-100 shadow-sm">
                        <Card.Header className="bg-success text-white">
                            <Card.Title className="mb-0">Ijara</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            {latestIjara ? (
                                <>
                                    <p><strong>Raqam:</strong> {latestIjara.raqam}</p>
                                    <p>
                                        <strong>Muddati:</strong> {Utils.getDayDifference(latestIjara.dan, latestIjara.gacha)} kun
                                        -> {formatDate(latestIjara.dan)} - {formatDate(latestIjara.gacha)}</p>
                                    <p><strong>Izoh:</strong> {latestIjara.izoh || 'Izoh yo\'q'}</p>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span>{getStatusBadge(latestIjara.gacha)}</span>
                                        <Button
                                            variant="outline-success"
                                            size="sm"
                                            onClick={() => handleDownload(latestIjara.fayl)}
                                        >
                                            <FaDownload className="me-1"/> Yuklab olish
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <p className="text-muted">Ijara shartnomasi mavjud emas</p>
                            )}
                        </Card.Body>
                        <Card.Footer className="text-center">
                            <Button
                                variant="link"
                                size="sm"
                                onClick={() => {
                                    // navigate(`/rent?transport_id=${transport.id}`)
                                    setShowIj(true);
                                }
                                }
                            >
                                <FaEye className="me-1"/> Barcha ijaralar
                            </Button>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>

              {/*Transaction History Buttons*/}
            <Row className="mb-4">
              <Col md={12} className="mb-2">
                <Button
                  variant="warning"
                  className="w-100"
                  onClick={() => setShowBalanceTarixModal(true)}
                >
                    <TimeIcon size={18} /> Balans Tarix
                </Button>
              </Col>
              {/*<Col md={4} className="mb-2">*/}
              {/*  <Button */}
              {/*    variant="outline-success" */}
              {/*    className="w-100"*/}
              {/*    onClick={() => navigate(`/transactions/rent?transport_id=${transport.id}`)}*/}
              {/*  >*/}
              {/*    Ijara to'lovlari tarixi*/}
              {/*  </Button>*/}
              {/*</Col>*/}
              {/*<Col md={4} className="mb-2">*/}
              {/*  <Button */}
              {/*    variant="outline-warning" */}
              {/*    className="w-100"*/}
              {/*    onClick={() => navigate(`/transactions/putyovka?transport_id=${transport.id}`)}*/}
              {/*  >*/}
              {/*    Putyovka to'lovlari tarixi*/}
              {/*  </Button>*/}
              {/*</Col>*/}
            </Row>

            <Modal show={showPut} onHide={() => setShowPut(false)} fullscreen style={{ zIndex: 2000 }}>
                <Modal.Header closeButton className="custom-modal"  style={{backgroundColor: 'lightgrey'}}>
                    <Modal.Title className='ms-3'>{transport.davlat_raqam || transport.name} transport putyovkalari</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowPutyovka transportId={transport.id} />
                </Modal.Body>
            </Modal>
            <Modal show={showLit} onHide={() => setShowLit(false)} fullscreen style={{ zIndex: 2000 }}>
                <Modal.Header closeButton className="custom-modal"  style={{backgroundColor: 'lightgrey'}}>
                    <Modal.Title className='ms-3'>{transport.davlat_raqam || transport.name} transport litsenziyalari</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowLitsenziya transportId={transport.id} />
                </Modal.Body>
            </Modal>
            <Modal show={showIj} onHide={() => setShowIj(false)} fullscreen style={{ zIndex: 2000 }}>
                <Modal.Header closeButton className="custom-modal"  style={{backgroundColor: 'lightgrey'}}>
                    <Modal.Title className='ms-3'>{transport.davlat_raqam || transport.name} transport ijaralari</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowIjara transportId={transport.id} />
                </Modal.Body>
            </Modal>
            <Modal show={showBalanceTarixModal} onHide={() => setShowBalanceTarixModal(false)} fullscreen style={{ zIndex: 2000 }}>
                <Modal.Header closeButton className="custom-modal"  style={{backgroundColor: 'lightgrey'}}>
                    <Modal.Title className='ms-3'>{transport.davlat_raqam || transport.name} transport balans tarixi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TransportTarix transportId={transport.id} />
                </Modal.Body>
            </Modal>

        </Container>
    );
};

export default TransportShow;
